<template>
  <Toast />
  <div class="card" v-if="nuevoProducto">
    <!-- <CrudProveedor></CrudProveedor> -->
  </div>
  <ProductoCreate
    :mostrar="mostrarProductoModal"
    :producto="producto"
    @closeModal="cerrarModal"
    @actualizarListadoProductos="cargarProductos"
  ></ProductoCreate>

  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Parámetros</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Productos</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <router-link to="/productos" class="text-900 line-height-3">Listado de Productos</router-link>
    </li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Productos/Servicios
          <Badge size="xlarge" severity="success"> {{ totalRecords }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0 gap-2">
        <Button
          icon="pi pi-refresh"
          class="p-button-info p-button-outlined"
          v-tooltip.top="'Actualizar'"
          @click="cargarProductos"
        />
        <Button
          label="Nuevo"
          v-if="'Producto Crear' in auth.user.permissions"
          class="p-button-info p-button-lg"
          icon="pi pi-plus"
          v-tooltip.top="'Registrar Nuevo Producto'"
          @click="openModal"
          :disabled="cargando"
        ></Button>
      </div>
    </div>

    <!-- Filtros -->
    <div class="surface-100 p-2 border-round mt-3 mb-2 border-1 surface-border flex gap-2 align-items-end flex-wrap">
      <div class="flex-1" style="min-width: 150px">
        <strong>CÓD. INTERNO:</strong>
        <InputText
          v-model="filtros.codigo_interno"
          class="w-full"
          placeholder="Código..."
          @keyup.enter="buscarProductos"
        />
      </div>
      <div v-if="mostrar_codigo_origen" class="flex-1" style="min-width: 150px">
        <strong>CÓD. ORIGEN:</strong>
        <InputText
          v-model="filtros.codigo_origen"
          class="w-full"
          placeholder="Código origen..."
          @keyup.enter="buscarProductos"
        />
      </div>
      <div class="flex-2" style="min-width: 250px">
        <strong>DESCRIPCIÓN:</strong>
        <div class="p-input-icon-right w-full">
          <InputText
            v-model="filtros.descripcion"
            class="w-full"
            placeholder="Buscar producto..."
            @keyup.enter="buscarProductos"
          />
          <i class="pi pi-search" @click="buscarProductos" />
        </div>
      </div>
      <div class="flex-1" style="min-width: 150px">
        <strong>MARCA:</strong>
        <InputText v-model="filtros.fabrica" class="w-full" placeholder="Marca..." @keyup.enter="buscarProductos" />
      </div>
      <div class="flex-1" style="min-width: 180px" v-if="'Grupo Crear' in auth.user.permissions">
        <strong>GRUPO:</strong>
        <div class="p-inputgroup">
          <AutoComplete
            v-model="grupoSelected"
            :suggestions="grupos_sugeridos"
            field="nombre"
            placeholder="Buscar grupo..."
            class="w-full"
            @keyup.enter="buscarGrupos"
            @item-select="onGrupoSelect"
            @clear="onGrupoLimpiar"
          />
          <Button
            v-if="grupoSelected"
            icon="pi pi-times"
            class="p-button-warning p-button-sm"
            @click="onGrupoLimpiar"
          />
        </div>
      </div>
      <div class="flex-1" style="min-width: 200px" v-if="'Venta Facturar' in auth.user.permissions">
        <strong>ACTIVIDAD:</strong>
        <Dropdown
          v-model="filtros.codigo_actividad"
          :options="actividades"
          optionLabel="descripcion"
          optionValue="codigo"
          placeholder="Todas..."
          class="w-full"
          showClear
          @change="onCambiarActividad"
        />
      </div>
      <div>
        <Button icon="pi pi-search" class="p-button-info" v-tooltip.top="'Aplicar Filtros'" @click="buscarProductos" />
      </div>
    </div>

    <div class="mt-4">
      <DataTable
        ref="dtproductos"
        dataKey="id"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        :rowsPerPageOptions="[20, 50, 100, 500, 1000]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Productos"
        responsiveLayout="scroll"
        stripedRows
        showGridlines
        :value="productos"
        :loading="cargando"
        :paginator="true"
        :rows="lazyParams.rows"
        :totalRecords="totalRecords"
        :rowHover="true"
        :lazy="true"
        @page="onPage($event)"
        selectionMode="single click"
        @row-dblclick="editarProducto($event.data)"
      >
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>

        <template #empty>
          <div class="text-center p-4 text-sm">No existen Registros!</div>
        </template>

        <Column field="codigo_interno" header="CÓD.INT." style="width: 100px" class="text-right"></Column>

        <Column
          v-if="mostrar_codigo_origen"
          field="codigo_origen"
          header="ORIG"
          style="min-width: 60px; max-width: 70px"
          class="text-center"
        >
          <template #body="{ data }">
            <span v-if="data.codigo_origen" v-tooltip.top="data.codigo_origen" class="codigo-origen-badge">
              {{ data.codigo_origen.length > 6 ? data.codigo_origen.substring(0, 6) + '...' : data.codigo_origen }}
            </span>
            <span v-else class="text-400">-</span>
          </template>
        </Column>

        <Column field="descripcion" header="DESCRIPCIÓN/DETALLE" style="min-width: 300px; font-weight: bold">
          <template #body="{ data }">
            <span>{{ data.descripcion }}</span>
            <span
              v-if="esUnidadValida(data.unidad_medida_nombre)"
              style="font-size: 0.8em; background: #e0e0e0; padding: 2px; border-radius: 3px; margin-left: 5px"
            >
              {{ data.unidad_medida_nombre }}
            </span>
          </template>
        </Column>

        <Column v-if="mostrar_medidas" field="medidas" header="DIMENSIONES" class="text-right"></Column>

        <Column field="imagen" header="IMAGEN" v-if="'Producto VerImagen' in auth.user.permissions">
          <template #body="{ data }">
            <template v-if="data.imagen">
              <Image :src="'data:image/png;base64, ' + data.imagen" width="30" preview></Image>
            </template>
            <template v-else><p>---</p></template>
          </template>
        </Column>

        <Column field="fabricas.nombre" header="MARCA">
          <template #body="{ data }">
            {{ data.fabricas?.nombre || '-' }}
          </template>
        </Column>
        <Column field="grupo_nombre" header="GRUPO" v-if="'Grupo Crear' in auth.user.permissions">
          <template #body="{ data }">
            {{ data.grupo_nombre && data.grupo_nombre !== 'NO DEFINIDO' ? data.grupo_nombre : '' }}
          </template>
        </Column>
        <Column class="text-center" field="stock_actual" header="CANT.">
          <template #body="{ data }">
            <div v-if="data.tipo_catalogo == 1" :class="claseEstado2(data)">
              {{ sinDecimal(data.stock_actual) }}
            </div>
            <div v-else>SERVICIO</div>
          </template>
        </Column>

        <Column field="precio_compra" header="P.COMPRA" class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.precio_compra) }}
          </template>
        </Column>

        <Column v-if="mostrar_precio_cif" field="precio_cif" header="P.CIF" class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.precio_cif ?? 0) }}
          </template>
        </Column>

        <Column field="precio_sugerido" header="P.VENTA" class="text-right font-bold font-medium">
          <template #body="{ data }">
            <span v-if="data.precio_venta == 0">
              {{ convertirNumeroGermanicFormat(data.precio_sugerido) }}
            </span>
            <span v-else>
              {{ convertirNumeroGermanicFormat(data.precio_venta) }}
            </span>
          </template>
        </Column>

        <Column field="pv2" header="P.MAYORISTA" class="text-right" v-if="maneja_mas_de_un_precio">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.pv2 ?? 0) }}
          </template>
        </Column>

        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado]">
              {{ data.estado_texto }}
            </span>
          </template>
        </Column>

        <Column header="ACCIONES" style="text-align: center; width: 100px">
          <template #body="slotProps">
            <Button
              class="p-button-info"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)"> </Menu>
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog v-model:visible="deleteProdModal" :style="{ width: '450px' }" header="Confirmar" :modal="true">
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="producto"
          >¿Estás seguro que quieres eliminar el producto: <b>{{ producto.descripcion }}</b
          >?</span
        >
      </div>
      <template #footer>
        <Button
          label="No, Cancelar"
          icon="pi pi-times"
          class="p-button-success p-button-lg"
          @click="deleteProdModal = false"
        />
        <Button label="Sí, Eliminar" icon="pi pi-check" class="p-button-danger p-button-lg" @click="deleteProducto" />
      </template>
    </Dialog>

    <ProductoImagenes
      v-if="verImagenes"
      :show="verImagenes"
      :producto_id="ProductoImagenes"
      @closeModal="ocultarDialog"
      @actualizarListado="cargarProductos"
    ></ProductoImagenes>
  </div>
</template>

<script>
import ProductService from '@/service/ProductService'
import ProductoCreate from '@/module/productos/ProductoCreate.vue'
import { useAuth } from '@/stores'
import ProductoImagenes from '@/module/productos/ProductoImagenes.vue'
import EmpresaService from '@/service/EmpresaService'

export default {
  components: { ProductoCreate, ProductoImagenes },
  data() {
    return {
      nuevoProducto: false,
      totalRecords: 0,
      productos: [],
      cargando: false,
      mostrarProductoModal: false,
      producto: {},
      deleteProdModal: false,
      lazyParams: {
        page: 1,
        rows: 20
      },
      actividades: [],
      filtros: {
        codigo_interno: null,
        codigo_origen: null,
        descripcion: '',
        fabrica: '',
        grupo: '',
        codigo_actividad: null,
        grupo_id: null
      },
      claseEstado: ['status-outofstock', 'status-instock'],
      claseEstado2: (data) => {
        if (data.stock_actual <= 0) {
          return 'outofstock'
        } else if (data.stock_actual <= 10) {
          return 'lowstock'
        } else {
          return 'instock'
        }
      },
      verImagenes: false,
      ProductoImagenes: null,
      ultimo_codigo_interno: null,
      parametros_sistema: [],
      mostrar_precio_cif: false,
      stock_decimales: false,
      mostrar_codigo_origen: false,
      mostrar_medidas: false,
      maneja_mas_de_un_precio: false,
      empresa: {},
      grupos_sugeridos: [],
      grupoSelected: null
    }
  },
  productoService: null,
  auth: null,
  empresaService: null,
  created() {
    this.auth = useAuth()
    this.productoService = new ProductService()
    this.empresaService = new EmpresaService()
  },
  mounted() {
    this.cargarProductos()
    this.empresaService.getFirstEmpresa().then((response) => {
      this.empresa = { ...response.data }
    })
  },
  methods: {
    buscarGrupos() {
      if (!this.grupoSelected || this.grupoSelected.length < 2) return
      this.productoService.buscarGrupos({ texto: this.grupoSelected }).then((response) => {
        this.grupos_sugeridos = response.grupos ?? []
      })
    },
    onGrupoSelect(event) {
      this.filtros.grupo_id = event.value.id
      this.buscarProductos()
    },
    onGrupoLimpiar() {
      this.grupoSelected = null
      this.filtros.grupo_id = null
      this.buscarProductos()
    },
    async onCambiarActividad() {
      if (!this.filtros.codigo_actividad) {
        this.buscarProductos()
        return
      }

      if (!this.empresa.id) {
        const response = await this.empresaService.getFirstEmpresa()
        this.empresa = { ...response.data }
      }

      this.empresaService
        .updateEmpresa(this.empresa.id, {
          ...this.empresa,
          codigoActividad: this.filtros.codigo_actividad,
          sucursal_id: 1
        })
        .then((response) => {
          if (response.res) {
            this.$toast.add({
              severity: 'success',
              summary: 'Actividad actualizada',
              detail: `Actividad cambiada a ${this.filtros.codigo_actividad}`,
              life: 2000
            })
          }
        })

      this.buscarProductos()
    },
    esUnidadValida(unidad) {
      if (!unidad) return false

      const valoresInvalidos = ['NO DEFINIDO', 'SIN UNIDAD DE MEDIDA', 'NO DEFINIDO']
      return !valoresInvalidos.some((invalido) => unidad.toUpperCase().trim() === invalido.toUpperCase())
    },
    sinDecimal(numero) {
      if (!numero && numero !== 0) return '0'
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(numero)
    },

    convertirNumeroGermanicFormat(numero) {
      if (!numero && numero !== 0) return '0.00'
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numero)
    },

    cargarProductos() {
      this.cargando = true

      const params = {
        page: this.lazyParams.page,
        per_page: this.lazyParams.rows,
        ...this.filtros
      }

      // Limpiar parámetros vacíos
      Object.keys(params).forEach((key) => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      this.productoService
        .getProductosPaginados(params)
        .then((response) => {
          if (response && response.data) {
            this.productos = response.data
            this.totalRecords = response.total || response.data.length
            this.parametros_sistema = response.parametros_sistema || []
            this.ultimo_codigo_interno = response.ultimo_codigo_interno

            this.actividades = response.actividades_economicas || []

            // Aplicar parámetros del sistema
            this.parametros_sistema.forEach((parametro) => {
              if (parametro.nombre == 'mostrar_cif' && parametro.estado == 1) {
                this.mostrar_precio_cif = true
              }
              if (parametro.nombre == 'stock_decimales' && parametro.estado == 1) {
                this.stock_decimales = true
              }
              if (parametro.nombre == 'mostrar_codigo_origen') {
                this.mostrar_codigo_origen = true
              }
              if (parametro.nombre == 'mostrar_medidas') {
                this.mostrar_medidas = true
              }
              if (parametro.nombre == 'maneja_mas_de_un_precio' && parametro.estado == 1) {
                this.maneja_mas_de_un_precio = true
              }
            })
          } else {
            this.productos = []
            this.totalRecords = 0
          }
          this.cargando = false
        })
        .catch((error) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar productos: ' + error.message,
            life: 3000
          })
          this.productos = []
          this.totalRecords = 0
          this.cargando = false
        })
    },

    onPage(event) {
      this.lazyParams.page = event.page + 1
      this.lazyParams.rows = event.rows
      this.cargarProductos()
    },

    buscarProductos() {
      this.lazyParams.page = 1
      this.cargarProductos()
    },

    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions
      return [
        {
          label: 'Editar',
          disabled: 'Producto Editar' in permisosUsuarioAuth ? false : true,
          icon: 'pi pi-pencil',
          command: () => {
            this.editarProducto(datos)
          }
        },
        {
          label: 'Ver Detalle',
          disabled: 'Producto Ver Detalle' in permisosUsuarioAuth ? false : true,
          icon: 'pi pi-eye',
          command: () => {
            this.verDetalle(datos)
          }
        },
        {
          label: 'Ver Imágenes',
          visible: 'Producto VerImagen' in permisosUsuarioAuth ? true : false,
          icon: 'pi pi-image',
          command: () => {
            this.mostrar_imagenes(datos.id)
          }
        },
        {
          label: 'Eliminar',
          disabled: 'Producto Eliminar' in permisosUsuarioAuth ? false : true,
          icon: 'pi pi-trash',
          command: () => {
            this.confirmDeleteProducto(datos)
          }
        }
      ]
    },

    ocultarDialog() {
      this.verImagenes = false
    },

    mostrar_imagenes(producto_id) {
      this.ProductoImagenes = producto_id
      this.verImagenes = true
    },

    openModal() {
      this.producto = {
        estado: 1,
        estado_texto: 'Activo',
        stock_minimo: 0,
        stock_maximo: 0,
        precio_sugerido: 0,
        tipo_catalogo: 1,
        codigo_interno: this.ultimo_codigo_interno ?? ''
      }
      this.mostrarProductoModal = true
    },

    cerrarModal() {
      this.mostrarProductoModal = false
      this.producto = {}
    },

    editarProducto(info_producto) {
      this.producto = { ...info_producto }

      // Convertir valores numéricos
      this.producto.stock_minimo = parseInt(this.producto.stock_minimo || 0)
      this.producto.stock_maximo = parseInt(this.producto.stock_maximo || 0)
      this.producto.precio_sugerido = parseFloat(this.producto.precio_sugerido || 0)
      this.producto.precio_compra = parseFloat(this.producto.precio_compra || 0)

      if (this.stock_decimales) {
        this.producto.stock_actual = parseFloat(this.producto.stock_actual || 0)
      } else {
        this.producto.stock_actual = parseInt(this.producto.stock_actual || 0)
      }

      this.producto.tipo_catalogo = parseInt(this.producto.tipo_catalogo || 1)
      this.producto.precio_cif = parseFloat(this.producto.precio_cif || 0)
      this.producto.pv2 = parseFloat(this.producto.pv2 || 0)
      this.producto.comision_medico = parseFloat(this.producto.comision_medico || 0)

      this.producto.es_comisionable = Boolean(this.producto.es_comisionable)
      this.producto.ubicacion = this.producto.ubicacion || ''

      this.mostrarProductoModal = true
    },

    verDetalle(producto) {
      this.$router.push(`/producto/${producto.id}/detalle`)
    },

    confirmDeleteProducto(producto) {
      this.producto = { ...producto }
      this.deleteProdModal = true
    },

    deleteProducto() {
      this.productoService.deleteProducto(this.producto).then((response) => {
        if (response.status == 200) {
          this.$toast.add({
            severity: 'success',
            summary: 'Éxito',
            detail: response.mensaje,
            life: 3000
          })
          this.productos = this.productos.filter((val) => val.id !== this.producto.id)
          this.deleteProdModal = false
          this.producto = {}
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: response.mensaje,
            life: 3000
          })
          this.deleteProdModal = false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.p-invalid {
  color: red;
}
.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #ff5252;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}
</style>
